
<template>
  <div class="float_button">
    <div @click="onBtnClicked"
         ref="floatButton"
         :class="{'flex_center': isRight,'flex_center_end': isLeft}"
         class="float_info"
         :style="{'width': itemWidth + 'px', 'height': itemHeight + 'px', 'left': left + 'px', 'top': top + 'px'}">
      <img :src="img"
           v-if="isImg"
           alt=""
           srcset="">
      <div v-if="!isImg"
           class="branch">{{branchName}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clientWidth: 0,
      clientHeight: 0,
      timer: null,
      currentTop: 0,
      left: 0,
      top: 0,
      itemWidth: 80,
      itemHeight: 54,
      isRight: true,
      isLeft: false
    }
  },
  props: {
    isImg: {
      // 是否是图标
      type: Boolean
    },
    branchName: {
      // 是学生还是老师
      type: String,
      default: '员工'
    },
    img: {
      // 按钮图标
      type: String,
      default: require('../assets/img/abnormal.png')
    },
    gapWidth: {
      // 距离左右两边距离
      type: Number,
      default: 15
    },
    coefficientHeight: {
      // 从上到下距离比例
      type: Number,
      default: 0.3
    }
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth
    this.clientHeight = document.documentElement.clientHeight
    this.left = this.clientWidth - (44 + 10)
    this.top = this.clientHeight * this.coefficientHeight
  },
  methods: {
    onBtnClicked() {
      this.$emit('onFloatBtnClicked')
    },
    handleScrollStart() {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleScrollEnd()
      }, 300)
      this.currentTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (this.left > this.clientWidth / 2) {
        this.left = this.clientWidth - 44
      } else {
        this.left = -22
      }
    },
    handleScrollEnd() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop === this.currentTop) {
        if (this.left > this.clientWidth / 2) {
          this.$refs.float_info
          this.left = this.clientWidth - (44 + 10)
        } else {
          this.left = this.gapWidth
        }
        clearTimeout(this.timer)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const floatButton = this.$refs.floatButton
      floatButton.addEventListener('touchstart', () => {
        floatButton.style.transition = 'none'
      })

      // 在拖拽的过程中，组件应该跟随手指的移动而移动。
      floatButton.addEventListener('touchmove', e => {
        this.itemWidth = 52
        this.itemHeight = 52
        // console.log('移动中', e)
        if (e.targetTouches.length === 1) {
          // 一根手指
          let touch = e.targetTouches[0]
          this.left = touch.clientX - 20
          this.top = touch.clientY - 25
        }
      })

      // 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
      floatButton.addEventListener('touchend', () => {
        floatButton.style.transition = 'all 0.3s'
        this.itemWidth = 80
        if (this.left > document.documentElement.clientWidth / 2) {
          this.isRight = true
          this.isLeft = false
          this.left = document.documentElement.clientWidth - (44 + 10)
        } else {
          this.left = -80 + 44 + 10
          this.isRight = false
          this.isLeft = true
        }
      })
    })
  },
  beforeDestroy() {
    // 添加监听页面滚动
    window.removeEventListener('scroll', this.handleScrollStart)
  },
  destroyed() {}
}
</script>
<style lang="less">
.float_button {
  .float_info {
    transition: all 0.3s;
    position: fixed;
    bottom: 436px;
    right: 0;
    // width: 80px;
    // height: 52px;
    // display: flex;
    // align-items: center;
    z-index: 999;
    background: rgba(230, 228, 228, 0.5);
    border-radius: 27px;
    // border-top-left-radius: 26px;
    // border-bottom-left-radius: 26px;
    padding-left: 3px;
    padding-right: 3px;
    border: 1px solid rgb(212, 210, 210);
    cursor: pointer;
    img {
      width: 44px;
      height: 44px;
    }
    .branch {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      line-height: 44px;
      text-align: center;
      background-color: #7daee9;
      color: #fff;
      font-size: 14px;
    }
  }
}
</style>